import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceFoodCertificateDetail } from 'modules/suppliers/types';

// export type FoodCertificateDetail =
//   typeof schemas.CertificateDetailFromKios._type;
export type FoodCertificateDetail = ReplaceFoodCertificateDetail;

interface UseFoodCertificateDetailsProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
  certificateOperationCode?: string;
}

const useFoodCertificateDetails = (props: UseFoodCertificateDetailsProps) => {
  const { supplierProfileOperationCode, customerOperationCode, certificateOperationCode } = props;

  const service = useService();

  return useQuery({
    queryKey: ['foodCertificateDetails', customerOperationCode],
    queryFn: async () => {
      try {
        if (
          !service ||
          !customerOperationCode ||
          !supplierProfileOperationCode ||
          !certificateOperationCode
        ) {
          return null;
        }

        const res: FoodCertificateDetail =
          await service.SupplierProfileController_getCertificateDetail({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
              certificateOperationCode,
            },
          });
        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useFoodCertificateDetails;
